import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { PricesListResponse, StripePrice } from "./types";

export const CATALOG_PRICES_QUERY_KEY = ["admin", "catalog", "prices"] as const;

async function fetchPrices(): Promise<readonly StripePrice[]> {
  const res = await httpClient<PricesListResponse>("/api/admin/catalog/prices");
  return res.items;
}

export function usePricesList() {
  return useQuery({
    queryKey: CATALOG_PRICES_QUERY_KEY,
    queryFn: fetchPrices,
    staleTime: 60_000,
  });
}
